import { render, staticRenderFns } from "./RxField.vue?vue&type=template&id=b783a00c"
import script from "./RxField.vue?vue&type=script&lang=js"
export * from "./RxField.vue?vue&type=script&lang=js"
import style0 from "./RxField.vue?vue&type=style&index=0&id=b783a00c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports